'use client';

import _toConsumableArray from "/codebuild/output/src796/src/s3/01/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import 'react';
import 'react/jsx-runtime';
import '@mantine/hooks';
import { useMantineStylesTransform } from '../../MantineProvider/Mantine.context.mjs';
import '../../MantineProvider/default-theme.mjs';
import '../../MantineProvider/MantineProvider.mjs';
import { useMantineTheme } from '../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import '../../MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
function useStylesTransform(_ref) {
  var _useMantineStylesTran;
  var props = _ref.props,
    stylesCtx = _ref.stylesCtx,
    themeName = _ref.themeName;
  var theme = useMantineTheme();
  var stylesTransform = (_useMantineStylesTran = useMantineStylesTransform()) === null || _useMantineStylesTran === void 0 ? void 0 : _useMantineStylesTran();
  var getTransformedStyles = function getTransformedStyles(styles) {
    if (!stylesTransform) {
      return [];
    }
    var transformedStyles = styles.map(function (style) {
      return stylesTransform(style, {
        props: props,
        theme: theme,
        ctx: stylesCtx
      });
    });
    return [].concat(_toConsumableArray(transformedStyles), _toConsumableArray(themeName.map(function (n) {
      var _theme$components$n;
      return stylesTransform((_theme$components$n = theme.components[n]) === null || _theme$components$n === void 0 ? void 0 : _theme$components$n.styles, {
        props: props,
        theme: theme,
        ctx: stylesCtx
      });
    }))).filter(Boolean);
  };
  return {
    getTransformedStyles: getTransformedStyles,
    withStylesTransform: !!stylesTransform
  };
}
export { useStylesTransform };